// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { FbtParam, fbt } from "fbt";

import Paragraph from "components/ui/Paragraph";
import React from "react";
import { useTestRunState } from "store/testrun";

const EndTestSuccessForProfile: React.FunctionComponent = () => {
  const testRunState = useTestRunState();
  const firstname = testRunState.testRun?.profileDetails?.firstname;
  if (firstname) {
    return (
      <Paragraph>
        <fbt desc="Healthpulse end test: completed test">
          You successfully completed a HealthPulse@home COVID-19 Specimen
          Collection Kit for
          <strong>
            <FbtParam name="first name">{firstname}</FbtParam>
          </strong>. Please put any remaining packaging in the garbage.
        </fbt>
      </Paragraph>
    );
  } else {
    return (
      <Paragraph>
        <fbt desc="Healthpulse end test: completed test">
          You successfully completed a HealthPulse@home COVID-19 Specimen
          Collection Kit. Please put any remaining packaging in the garbage.
        </fbt>
      </Paragraph>
    );
  }
};

export default EndTestSuccessForProfile;
